import { Dialog } from '@angular/cdk/dialog';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { isObject } from '@core/helpers';

import { TOKEN, logout } from './auth.state';
import { Restriction } from './users.entity';

type RestrictionsResponse = {
  restrictions: Restriction[];
};

function isRestrictionsResponse(body: any): body is RestrictionsResponse {
  return isObject(body) && 'restrictions' in body;
}

@Injectable({
  providedIn: 'root'
})
export class AuthHttpInterceptor implements HttpInterceptor {
  private readonly dialog = inject(Dialog);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = TOKEN();

    const isCdnJson = request.url.includes('cdn/') && request.url.includes('.json');

    if (!isCdnJson && authToken !== null) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${authToken}`)
      });
    }

    return next.handle(request).pipe(catchError((event: any) => this.handleError(event)));
  }

  private handleError(event: any): Observable<any> {
    if (event instanceof HttpErrorResponse) {
      const body: any = event.error?.data;

      if (403 === event.status && isRestrictionsResponse(body)) {
        this.openRestrictionsDialog(body.restrictions);

        return of(undefined);
      } else if (419 === event.status) {
        logout();
      }
    }

    throw event;
  }

  private async openRestrictionsDialog(restrictions: Restriction[]) {
    const cmp = await import('./dialogs/restrictions/restrictions.dialog');

    this.dialog.open(cmp.default, {
      data: restrictions
    });
  }
}
